import { Component, OnDestroy, Pipe, PipeTransform, HostListener, ViewChild, Inject } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {fromEvent} from 'rxjs';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import {ApiService} from '../shared/api.service';
import {AssignmentsService} from '../shared/assignments.service';
import {GettyService} from '../getty/getty.service';
import {ImagesService} from '../shared/images.service';
import {StatusMap} from '../assignments/assignment.model';
import {SlideshowService} from './slideshow.service';
import {routerTransition} from '../router.animations';
import {Utils} from '../utils';
import { DomSanitizer } from '@angular/platform-browser';
import { PermissionsService } from '../shared/permissions.service';
import { Permissions } from '../shared/permissions.enum';
import { MatDrawer } from '@angular/material/sidenav';

@Pipe({name: 'sites'})
export class SitesPipe implements PipeTransform {
    transform(list, primary): string {
        if( !list ) return;
        return list.filter(item => item.permalink != '' && primary ? item.primary : !item.primary);
    }
}
@Component({
    selector: 'slideshow-component',
    templateUrl: 'slideshow.component.html',
    animations: [ routerTransition ],

})

export class SlideshowComponent implements OnDestroy {
    @ViewChild('slideDrawer') public slideDrawer: MatDrawer;

    user;
    statuses;
    trayOpen = false;
    uploadSubscription;
    showAdditionalMenu = false;
    showPublishReadyBtn = false;
    deleteSubscription;
    slideshowAssignmentTitle = this.utils.rand();
    storageSubscription;
    focusSubscription;
    lockSubscription;
    requestAssignmentSbuscription;
    previewAnimationComplete = false;
    writingAnimationComplete = false;

    @ViewChild('actions') actions;
    @ViewChild('group') tabGroup;

    @HostListener('window:beforeunload', ['$event']) 
    noGo (e) {
        if( this.slideshow.locked || this.slideshow.objEq(this.slideshow.getBackup(this.slideshow), this.slideshow.backup) ) {
            return true;
        }
        e.preventDefault();
        e.returnValue = undefined;
        return undefined;
    }
    @HostListener('document:keydown.escape', ['$event'])
    removeRetry(e) {
        if( this.slideshow.showRetryMessage ) {
            this.slideshow.destroyRetry();
        }
    }

    public get Permissions(): typeof Permissions {
        return Permissions; 
    }

    constructor(
        private api: ApiService, 
        private assignments: AssignmentsService,
        private dialog: MatDialog,
        private route: ActivatedRoute,
        private router: Router,
        public slideshow: SlideshowService,
        public imagesService: ImagesService,
        public utils: Utils,
        public gettyService: GettyService,
        public permissionsService: PermissionsService,
    ) {
        this.gettyService.subscribedEvents = [
            'REQUESTFIRSTLOAD',
            'FILTERSCHANGED',
            'INSERTINTOASSIGNMENT',
            'DOWNLOADING',
            'RESETERRORS'
        ];
        this.storageSubscription = fromEvent(window, 'storage').subscribe(e => {
            this.gettyService.handleStorageEvents(e);
        });
        this.focusSubscription = fromEvent(window, 'focus').subscribe(() => {
            if( !this.slideshow.locked ) {
                localStorage.setItem(this.gettyService.popoutStorageKey, JSON.stringify({
                    action: 'WINDOWFOCUSED',
                    currentAssignment: {
                        id: this.slideshow.assignment.id,
                        title: this.slideshow.assignment.title
                    }
                }))
            }
        });
        this.lockSubscription = this.slideshow._locked.subscribe(locked => {
            if( !locked ) {
                localStorage.setItem(this.gettyService.popoutStorageKey, JSON.stringify({
                    action: 'ASSIGNMENTLOADED',
                    currentAssignment: {
                        id: this.slideshow.assignment.id,
                        title: this.slideshow.assignment.title
                    }
                }));
            }
        });
        this.user = this.api.getProp('user');
        if( this.user.role == 'editor' || this.user.role == 'administrator' ) {
            this.showAdditionalMenu = true;
        }
        this.route.params.subscribe(params => {
            if( params.hasOwnProperty('id') ) {
                this.slideshow.loadSlideshow(params.id);
            }
        });
        this.statuses = StatusMap;
        this.uploadSubscription = this.imagesService.uploadComplete.subscribe(images => {
            this.trayOpen = false;
        });
        this.deleteSubscription = this.assignments.deleted.subscribe(data => {
            this.reset();
            this.router.navigate(['/assignments', 'queue']);
        });
        if( !this.slideshow.assignment ) {
            const assignmentSubscription = this.slideshow.assignmentLoaded.subscribe(assignment => {
                this.initButtons();
                assignmentSubscription.unsubscribe();
            });
        } else {
            this.initButtons();
        }
        this.slideshow.statusChange.subscribe(() => {
            this.initButtons();
        });
    }
    tabChanged(e) {
        this.previewAnimationComplete = false;
        this.writingAnimationComplete = false;
        this.slideshow.currentTabIndex = this.tabGroup.selectedIndex;
    }
    animationComplete(e) {
        if( this.tabGroup.selectedIndex == 3 ) {
            this.previewAnimationComplete = true;
        }        
        if( this.tabGroup.selectedIndex == 0 ) {
            this.writingAnimationComplete = true;
        }
    }
    initButtons() {
        const status = this.slideshow.assignment.status;
        if( ['publish_ready', 'publish', 'imported', 'future'].indexOf(status) === -1 ) {
            this.showPublishReadyBtn = true;
        } else {
            this.showPublishReadyBtn = false;
        }
    }
    hasPublishedSites() {
        const sites = this.slideshow.assignment.sites;
        const len = sites.length;
        if( len <= 1 ) {
            return false;
        }
        for(var i = 0; i < len; i++) {
            const site = sites[i];
            if( site.post_id ) {
                return true;
            }
        }
        return false;
    }
    getState(outlet) {
        return outlet.activatedRouteData.state + this.slideshow.slideIndex;
    }
    toggle() {
        this.trayOpen = !this.trayOpen;
    }
    reset() {
        this.trayOpen = false;
        this.showPublishReadyBtn = false;
        this.slideshow.resetSlideshow();
        this.imagesService.reset();
        this.gettyService.resetErrors();
        if( this.uploadSubscription ) {
            this.uploadSubscription.unsubscribe();
        }
        if( this.lockSubscription ) {
            this.lockSubscription.unsubscribe();
        }
        if( this.storageSubscription ) {
            this.storageSubscription.unsubscribe();
        }
        if( this.focusSubscription ) {
            this.focusSubscription.unsubscribe();
        }
    }
    delete() {
        this.assignments.delete([this.slideshow.assignment])
    }
    maybeAddComment() {
        const dialog = this.dialog.open(CommentDialog);
        dialog.afterClosed().subscribe(comment => {
            if( typeof comment === 'string' ) {
                this.slideshow.addComment(comment);
                this.slideshow.sendRevisionRequest();
            }
        });
    }
    deleteMultiple(slideList) {
        slideList = slideList.filter(slideId => {
            return slideId < this.slideshow.slides.length && !this.slideshow.slides[slideId].outro;
        });

        slideList = slideList.sort((a, b) => a - b);

        const confirmDialog = this.dialog.open(DeleteMultipleConfirmDialog, {
            data: {
                slides: {
                    slides: this.slideshow.slides,
                    slideIndexes: slideList,
                    assignmentId: this.slideshow.assignment.id
                }
            }
        });
        confirmDialog.afterClosed().subscribe(slides => {
            if(!slides) return;
            this.slideshow.removeSlides(slides.slideIndexes);
        });
    }
    ngOnDestroy() {
        if( this.deleteSubscription ) {
            this.deleteSubscription.unsubscribe();
        }
        if( this.slideshow.locked || this.slideshow.objEq(this.slideshow.getBackup(this.slideshow), this.slideshow.backup) ) {
            this.reset();
            return;
        }
        const dialog = this.dialog.open(GoBackDialog);
        dialog.afterClosed().subscribe(goBack => {
            if( goBack ) {
                this.slideshow.reload = true;
                this.router.navigate(['/slideshow', this.slideshow.assignment.id]);
            } else {
                this.reset();
            }
        });
    }
}
@Component({
    selector: 'go-back-dialog',
    template: `
        <h2 mat-dialog-title>Unsaved Changes</h2>
        <mat-dialog-content>
            <p>You have unsaved changes. Do you want to go back?</p>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button class="button" [mat-dialog-close]="false">Cancel</button>
            <button class="button" [mat-dialog-close]="true">Go Back</button>
        </mat-dialog-actions>`,
})
export class GoBackDialog {
    constructor() {}
}
@Component({
    selector: 'comment-dialog',
    template: `
        <h2 mat-dialog-title>Request Revision</h2>
        <mat-dialog-content id="revision-request">
            <div class="input-wrap"><textarea placeholder="Add a note" [(ngModel)]="comment" (keyup.enter)="send()"></textarea></div>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button class="button" [mat-dialog-close]="false">Cancel</button>
            <button class="button" [mat-dialog-close]="comment">Send</button>
        </mat-dialog-actions>`,
})
export class CommentDialog {
    comment = '';
    constructor(private ref: MatDialogRef<CommentDialog>) {}
    send() {
        this.ref.close(this.comment);
    }
}
@Component({
    selector: 'delete-multiple-dialog',
    template: `
        <h2 mat-dialog-title>Delete Slides</h2>
        <mat-dialog-content id="delete-multi-request">
            <div class="input-wrap"><textarea placeholder="1-4,8-11,15" [(ngModel)]="slides" (keyup.enter)="send()"></textarea></div>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button class="button" [mat-dialog-close]="false">Cancel</button>
            <button class="button" [mat-dialog-close]="slides">Delete</button>
        </mat-dialog-actions>`,
})
export class DeleteMultipleDialog {
    slides = '';
    constructor(private ref: MatDialogRef<DeleteMultipleDialog>) {}
    send() {
        this.ref.close(this.slides);
    }
}

@Component({
    selector: 'delete-multiple-confirm-dialog',
    template: `
        <h2 mat-dialog-title>Delete Slides</h2>
        <mat-dialog-content id="delete-multi-confirm">
            <p>Please confirm you wish to delete the following slides:</p>
            <div *ngFor="let i of data.slides.slideIndexes">
                <div class="slide-info">
                    <span class="slide-number">{{i}}</span>
                    <span class="slide-title">{{data.slides.slides[i].title}}</span>
                    <span class="slide-id">{{data.slides.slides[i].id}}</span>
                </div>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button class="button" [mat-dialog-close]="false">Cancel</button>
            <button class="button" [mat-dialog-close]="data.slides" (click)="downloadBackup()">Delete</button>
        </mat-dialog-actions>`,
})
export class DeleteMultipleConfirmDialog {
    fileUrl;
    assignmentId;
    constructor(private ref: MatDialogRef<DeleteMultipleConfirmDialog>, @Inject(MAT_DIALOG_DATA) public data: any) {
        this.assignmentId = data.slides.assignmentId;

        const slidesToDelete = data.slides.slides.filter((slide, index) => {
            return data.slides.slideIndexes.includes(index);
        });

        const json = JSON.stringify(slidesToDelete, null, 4);
        this.fileUrl = "data:text/json;charset=utf-8," + encodeURIComponent(json);
    }

    downloadBackup() {
        const link = document.createElement('a');
        link.setAttribute('target', '_blank');
        link.setAttribute('href', this.fileUrl);
        link.setAttribute('download', `backup-${this.assignmentId}.json`);
        document.body.appendChild(link);
        link.click();
        link.remove();
    }
}

@Component({
    selector: 'delete-multiple-error-dialog',
    template: `
        <h2 mat-dialog-title>Error</h2>
        <mat-dialog-content id="delete-multi-error-request">
            <p>The input had a problem. Please ensure the text field only contains numbers, dashes, and commas.</p>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button class="button" [mat-dialog-close]="false">Close</button>
        </mat-dialog-actions>`,
})
export class DeleteMultipleErrorDialog {
    constructor(private ref: MatDialogRef<DeleteMultipleErrorDialog>) {}
    send() {
        this.ref.close();
    }
}

